var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotoOpenFileFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.113 15.8053V14.813C21.113 12.834 19.9267 12.4234 18.6264 12.6572L7.73346 14.6248C6.42744 14.8586 5.46932 16.0334 5.46932 17.4022V19.9344C5.46932 20.8583 4.82486 21.651 3.94088 21.8107L3.74697 21.8449C2.98275 21.9818 2.41814 22.6662 2.41814 23.4703L2.40674 65.873C2.40674 66.7114 2.75463 66.6316 3.01697 66.5631L56.5522 53.925C57.3164 53.7881 57.881 53.1037 57.881 52.2996V14.3339C57.881 13.313 56.9913 12.5374 56.0161 12.7085L23.9018 18.2348C22.4475 18.4915 21.113 17.944 21.113 15.8053Z",
    fill: "#F3AB47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9704 52.1513L70.3539 27.491C70.5592 27.0461 70.5991 26.5272 70.3824 26.088C70.12 25.5519 69.5782 25.2268 68.7056 25.3865L36.6142 30.8729C35.1199 31.1296 34.6238 31.409 33.9052 33.8899C33.1866 36.3708 32.8444 39.2394 30.6886 39.4733L18.7349 41.4865C16.4935 41.8971 15.5525 44.2696 15.5525 44.2696L2.90869 66.5916L56.8032 53.9136C57.5731 53.7824 58.4457 53.0638 58.9704 52.1513Z",
    fill: "#FFE36C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7056 25.9854L37.424 31.1924C35.3709 31.5859 34.8918 32.0592 34.2816 34.2835C33.5972 36.7757 32.8444 39.844 30.6886 40.0778L18.7349 42.091",
    stroke: "#FFF9C4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotoOpenFileFolder);
export default __webpack_public_path__ + "static/media/noto_open-file-folder.f992bd9441804531870b54da990efb1f.svg";
export { ForwardRef as ReactComponent };